import React from "react"
import { Col, Container, Form, Row } from "react-bootstrap"
import { useNavigate, useLocation } from "react-router-dom"
import { pingLogin } from "../../api/AuthService"
import { FETCH_PING } from "../../constant/Constants"
import Logo from "../../resource/img/logo.png"

// HOC to provide router props to class component
function withRouter(Component) {
   function ComponentWithRouterProp(props) {
      const navigate = useNavigate()
      const location = useLocation()
      
      return (
         <Component
            {...props}
            navigate={navigate}
            location={location}
            history={{ push: navigate }}
         />
      )
   }

   return ComponentWithRouterProp
}

class Login extends React.Component {
   constructor(props) {
      super(props)
      this.state = {
         message: "",
         loading: true,
      }
   }

   componentDidMount() {
      const rawParams = new URLSearchParams(this.props.location.search)
      const hasRequiredParams = rawParams.has("code") && rawParams.has("state")

      if (!hasRequiredParams) {
         window.location.replace("/")
         return
      } else {
         this.setState({
            message: "",
            loading: true,
         })
         
         const ALLOWED_PARAMS = ["code", "state", "session_state"]
         const sanitizedParams = new URLSearchParams()
         ALLOWED_PARAMS.forEach((key) => {
            if (rawParams.has(key)) {
               const paramKey = key === "session_state" ? "state" : key
               sanitizedParams.set(paramKey, rawParams.get(key))
            }
         })
         const userType = localStorage.getItem("userType")
         sanitizedParams.set("userType", userType)
         pingLogin(`${FETCH_PING}?${sanitizedParams.toString()}`)
            .then(() => {
               this.setState({ loading: false })
               if (localStorage.getItem("gcas") && localStorage.getItem("gcas") !== "") {
                  this.props.navigate(`/${localStorage.getItem("gcas")}`)
               } else if (localStorage.getItem("unreleasedPartName") && localStorage.getItem("unreleasedPartName") !== "") {
                  const unreleasedPartName = localStorage.getItem("unreleasedPartName")
                  localStorage.removeItem("unreleasedPartName")
                  localStorage.removeItem("calledFrom")
                  this.props.navigate("/search/", { replace: true })
                  this.props.navigate(`/unreleasedData/${unreleasedPartName}`)
               } else if (localStorage.getItem("objectName") && localStorage.getItem("objectName") !== "") {
                  this.props.navigate(`/PDF/download/${localStorage.getItem("downloadtype")}/${localStorage.getItem("objectName")}`)
               } else {
                  this.props.navigate("/search")
               }
            })
            .catch((error) => {
               var errorMessage = ""
               if (error.response && error.response.status && error.response.status === 418) {
                  errorMessage = "418"
               } else {
                  errorMessage = "Login service issue. Please contact SpecReaderExt.im@pg.com for help."
               }
               this.setState({
                  message: errorMessage,
                  loading: false,
               })
            })
      }
   }

   render() {
      return (
         <React.Fragment>
            <Container fluid className="contentBackground sticky-top shadow">
               <Row>
                  <Col md="12">
                     <img src={Logo} alt="logo" style={{ width: "90px" }} />
                  </Col>
               </Row>
            </Container>
            <Container fluid>
               <Row>
                  <Col>
                     <Row>
                        <Col md={{ span: 6, offset: 3 }} style={{ marginTop: "10%" }}>
                           <br />
                           <p className="labels">
                              {this.state.loading ? (
                                 <h3 style={{ textAlign: "center", color: "white" }}>
                                    <i
                                       className="fa fa-spinner fa-spin"
                                       style={{ marginRight: "5px" }}
                                    />{" "}
                                    Granting access........
                                 </h3>
                              ) : this.state.message === "418" ? (
                                 <span style={{ fontSize: "16px" }}>
                                    You don't have permission to access this application.<br /><br />
                                    Please visit <a style={{ color: "white", textDecoration: "underline" }} href=" https://thejunction.pg.com/page/ppd/access-platform">The Junction</a> for access information. <br /><br />
                                    For assistance with external user access please email dsmhelp.im@pg.com
                                 </span>
                              ) : (
                                 <span style={{ textAlign: "center", color: "white", fontSize: "16px" }}>{this.state.message}</span>
                              )}
                           </p>
                        </Col>
                     </Row>
                  </Col>
               </Row>
            </Container>
         </React.Fragment>
      )
   }
}

export default withRouter(Login)